import styled from '@emotion/styled';

import { getSpace } from './Box/helpers';
import { getSemanticColorVariable } from '../theme/colors';

// Local Typings
interface Props {
  borderWidth?: number;
  dividerWidth?: number | string;
  marginBottom?: number;
  marginTop?: number;
  marginY?: number;
}

// Local Variables
const setBorder: (props: Props) => string = ({ borderWidth = 2 }) =>
  `${borderWidth}px solid ${getSemanticColorVariable('divider')}`;

// Component Definition
const Divider = styled.hr<Props>(props => ({
  borderBottom: 'none',
  borderLeft: setBorder(props),
  borderRight: setBorder(props),
  borderTop: setBorder(props),
  marginBottom: getSpace([props.marginBottom, props.marginY],
    props.theme.spacing),
  marginTop: getSpace([props.marginTop, props.marginY],
    props.theme.spacing),
  width: props.dividerWidth,
}));

export default Divider;
